import { SIZE, ORIENTATION, SPACING } from 'app-v2/design-tokens'
import styled from 'styled-components'

const getSize = (size?: string) => {
    switch (size) {
        case SIZE.XXL:
            return SPACING.XXL
        case SIZE.XL:
            return SPACING.XL
        case SIZE.L:
            return SPACING.L
        case SIZE.S:
            return SPACING.S
        case SIZE.XS:
            return SPACING.XS
        case SIZE.XXS:
            return SPACING.XXS
        default:
            return SPACING.M
    }
}
export const StyledSpacer = styled.div`
    height: ${props =>
        props.orientation === ORIENTATION.HORIZONTAL
            ? '100%'
            : getSize(props.size)};
    width: ${props =>
        props.orientation === ORIENTATION.HORIZONTAL
            ? getSize(props.size)
            : '100%'};
`
